import { FC } from 'react';
import { ITile } from 'pages/StoryBlok/TileBanner/types';
import { isTitleExist } from 'pages/StoryBlok/TileBanner/utils';
import { renderRichText } from 'modules/stroyblok/services';
import { DefaultTile } from './DefaultTile';

export const DefaultTileContainer: FC<ITile> = ({
  blok,
  config,
  deviceType,
}) => {
  return (
    <DefaultTile
      blok={blok}
      config={config}
      deviceType={deviceType}
      getText={renderRichText}
      isTitleExist={isTitleExist}
    />
  );
};
